import { createApi } from '@reduxjs/toolkit/query/react';
import { urls } from '../../utils/helpers/ApiClient';
import axiosFetchBase from '../axiosFetchBase';

export const ldapApi = createApi({
  reducerPath: 'ldapApi',
  keepUnusedDataFor: 0,
  baseQuery: axiosFetchBase,
  endpoints: (builder) => ({
    ldapSync: builder.mutation({
      query() {
        return {
          url: urls.ldapSynchronization,
          method: 'POST',
        };
      },
    }),
    getLastSyncResult: builder.query({
      query: () => ({
        url: urls.ldapLastSyncResult,
      }),
    }),
  }),
});

export const { useGetLastSyncResultQuery, useLdapSyncMutation } = ldapApi;
